/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Criteria_DeletedInputs */

const en_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search criteria deleted`)
};

const de_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchkriterium gelöscht`)
};

const fr_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critère de recherche supprimé`)
};

const es_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criterio de búsqueda eliminado`)
};

const it_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criterio di ricerca eliminato`)
};

const nl_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekcriterium verwijderd`)
};

const pl_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kryterium wyszukiwania usunięte`)
};

const fi_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakukriteeri poistettu`)
};

const da_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søgekriterium slettet`)
};

const sv_jobs_criteria_deleted = /** @type {(inputs: Jobs_Criteria_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sökkriterium raderat`)
};

/**
* | output |
* | --- |
* | "Search criteria deleted" |
*
* @param {Jobs_Criteria_DeletedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_criteria_deleted = /** @type {((inputs?: Jobs_Criteria_DeletedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Criteria_DeletedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_criteria_deleted(inputs)
	if (locale === "fr") return fr_jobs_criteria_deleted(inputs)
	if (locale === "es") return es_jobs_criteria_deleted(inputs)
	if (locale === "it") return it_jobs_criteria_deleted(inputs)
	if (locale === "nl") return nl_jobs_criteria_deleted(inputs)
	if (locale === "pl") return pl_jobs_criteria_deleted(inputs)
	if (locale === "fi") return fi_jobs_criteria_deleted(inputs)
	if (locale === "da") return da_jobs_criteria_deleted(inputs)
	if (locale === "sv") return sv_jobs_criteria_deleted(inputs)
	return en_jobs_criteria_deleted(inputs)
});